import { render, staticRenderFns } from "./ymWu.vue?vue&type=template&id=2d814d5d&"
import script from "./ymWu.vue?vue&type=script&lang=js&"
export * from "./ymWu.vue?vue&type=script&lang=js&"
import style0 from "./ymWu.vue?vue&type=style&index=0&id=2d814d5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports